import { useMemo } from "react";
import type {
  AnalyticsQueryFilters,
  AnalyticsWidgetConfig,
} from "@sales-ops-amplify/shared";
import { useAnalyticsQuery } from "@/hooks/useAnalytics";
import { AnalyticsWidget } from "@/components/analytics/metric-widgets";

function WidgetCell({
  widget,
  filters,
}: {
  widget: AnalyticsWidgetConfig;
  filters: AnalyticsQueryFilters;
}) {
  const needsQuery =
    widget.kind !== "deal_summary" && (widget.metrics?.length ?? 0) > 0;
  const request = useMemo(
    () =>
      needsQuery
        ? {
            metrics: widget.metrics!,
            groupBy: widget.groupBy,
            filters,
          }
        : null,
    [needsQuery, widget.metrics, widget.groupBy, filters],
  );
  const query = useAnalyticsQuery(request, needsQuery);

  return (
    <AnalyticsWidget
      widget={widget}
      result={query.data}
      loading={query.isLoading}
    />
  );
}

export function AnalyticsDashboardGrid({
  widgets,
  filters,
}: {
  widgets: AnalyticsWidgetConfig[];
  filters: AnalyticsQueryFilters;
}) {
  if (widgets.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        This dashboard has no widgets yet.
      </p>
    );
  }
  return (
    <div className="space-y-5">
      {widgets.map((w) => (
        <WidgetCell key={w.id} widget={w} filters={filters} />
      ))}
    </div>
  );
}
